import { Component, EventEmitter, inject, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthLoginResponse, AuthResponse, AuthService } from './auth.service';

@Component({
  selector: 'app-manager-auth',
  imports: [FormsModule],
  templateUrl: './manager-auth.component.html'
})
export class ManagerAuthComponent {
  @Output() authenticated = new EventEmitter<AuthResponse>();
  @Output() backRequested = new EventEmitter<void>();

  protected username = '';
  protected password = '';
  protected managerAuthError = '';
  protected managerAuthLoading = false;

  private readonly authService = inject(AuthService);

  protected backToProfileSelection(): void {
    this.managerAuthError = '';
    this.backRequested.emit();
  }

  protected async authenticateManager(event: Event): Promise<void> {
    event.preventDefault();
    this.managerAuthError = '';

    const username = this.username.trim();

    if (!username || !this.password) {
      this.managerAuthError = 'El usuario y la contraseña son obligatorios.';
      return;
    }

    this.managerAuthLoading = true;

    try {
      const response = await this.authService.loginManager(username, this.password);

      if (response.ok) {
        const loginResponse = await response.json() as AuthLoginResponse;

        if (this.authService.isAuthResponse(loginResponse)) {
          this.authenticated.emit(loginResponse);
          return;
        }

        this.managerAuthError = 'No se ha podido completar la autenticación. Respuesta no reconocida.';
        return;
      }

      if (response.status === 401) {
        this.managerAuthError = 'El usuario o la contraseña no son correctos.';
        return;
      }

      if (response.status === 403) {
        this.managerAuthError = 'La cuenta de gestor no está activa.';
        return;
      }

      if (response.status === 502 || response.status === 504) {
        this.managerAuthError = 'El servicio de autenticación de gestores no está disponible. Inténtalo de nuevo más tarde.';
        return;
      }

      this.managerAuthError = 'No se ha podido completar la autenticación. Inténtalo de nuevo más tarde.';
    } catch {
      this.managerAuthError = 'No se ha podido contactar con el servicio de autenticación.';
    } finally {
      this.managerAuthLoading = false;
    }
  }
}
